// extracted by mini-css-extract-plugin
export var card = "_9o-1";
export var container = "_9o-0";